export default __webpack_public_path__ + "static/media/i.b54772fd.mp4";